import * as environments from './environments.json';
const envName = (window as any).__env;
export const environment = Object.assign({}, (environments as any).default[envName]);
